import React from 'react';
import ProfileForm from '../ProfileFrom'
import './style.css'

const Profilepage = ({ userID }) => {
    return(
        <div id="Contact" className="contact-area">
            <div className="container">               
                <div className="contact-content">
                    <h2 style={{fontSize: '26px', marginBottom: '26px'}}>Update Profile</h2>
                    <div className="contact-form">
                        <ProfileForm userID={userID}/>
                    </div>
                </div>
            </div>
        </div>
     )
}

export default Profilepage;